// extracted by mini-css-extract-plugin
export default {"BlogGallery":"style_BlogGallery__TwdGC","container":"style_container__TNPw9"};